import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { inset, pxToRem, shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { DRAWER_HEADER_TITLE_CLASSNAME } from "../constants/classNames";
var text = theme.text;
export var header = /*#__PURE__*/css(["position:relative;z-index:1;display:flex;align-items:center;padding:", ";", ";background-color:var(--neutral-white-base);.", "{", ";margin:0;}"], inset(16, 24), shadowDown, DRAWER_HEADER_TITLE_CLASSNAME, fontSize(text.HEADING.SM));
export var backBtn = /*#__PURE__*/css(["margin-right:", ";"], pxToRem(18));
export var closeBtn = /*#__PURE__*/css(["margin-left:auto;"]);